import { render, staticRenderFns } from "./MyPicture.vue?vue&type=template&id=6f1efaee&scoped=true"
import script from "./MyPicture.vue?vue&type=script&lang=js"
export * from "./MyPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1efaee",
  null
  
)

export default component.exports